import { render, staticRenderFns } from "./AddCertificateModal.vue?vue&type=template&id=1b78905b"
import script from "./AddCertificateModal.vue?vue&type=script&lang=js"
export * from "./AddCertificateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports